app.service('productPreviewService',function(console, modal, loading, cartManager) {
	var $self, $addServiceButton;
	var service, product;

	function loadSuccess(content) {
		modal.generate({
			content: content,
			id: 'services-dialog',
			callbackOpen: function() {
				setElements();
				setEvents();
				loading.stop();
			}
		});
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA ZAKŁADKI');
		loading.stop();
	}
	function load(serviceId, productId, outletCategoryId) {
		console.log('SPRAWDZENIE DOSTĘPNOŚCI USŁUGI - '+serviceId);
		loading.start();
		service = serviceId;
		product = productId;
		$.ajax({
			url:'/service-front-view.ltr',
			data : {
				serviceId: service,
				productId: product,
				outletCategoryId
			},
			success: function(html) {
				loadSuccess(html);
			},
			error: function() {
				loadError();
			}
		});
	}
	function setEvents() {
		$addServiceButton.on('click', function() {
			UA.pageInteraction('Usługi', 'Koszyk - Usługa');
			cartManager.addServiceWithProduct(service, product);
		});
	}
	function setElements() {
		$self = $('#about-service-box');
		$addServiceButton = $('.js-btn-add-service-with-product', $self);
	}
	function init(serviceId, productId, outletCategoryId = undefined){
		load(serviceId, productId, outletCategoryId);
	}
	return {
		init:init
	};
});
